import React from "react";
import logo from "../images/logo2.png";
import img1 from "../images/facebook.svg";
import img2 from "../images/email.svg";
import img3 from "../images/youtube.svg";
import img4 from "../images/linkedin.svg";
import img5 from "../images/whatsapp.svg";
import img6 from "../images/twitter.svg";

export default function Footer() {
  const classplusData = [
    {label:"About us",link:"https://classplusapp.com/aboutus"},
    {label:"Product",link:"https://classplusapp.com/teachers-delight"},
    // {label:"Classplus Academy",link:""},
    {label:"Contact us",link:"https://classplusapp.com/contactus"},
    {label:"Privacy Policy",link:"https://classplusapp.com/privacyPolicy"},
    {label:"Terms & Conditions",link:"https://classplusapp.com/termscondition"},
    {label:"Sitemap",link:"/#"},
  ];
  const contactData = [
    "1st Floor, D8,  Sector 3",
    "Noida, Uttar Pradesh 201301",
    "+91-7303069769",
  ];
  const connectData = [
    { img: img1, link: "https://www.facebook.com/classplusapp" },
    { img: img2, link: "mailto: support@classplusapp.com" },
    { img: img3, link: "https://www.youtube.com/channel/UCp0yDDnyu-C-0Bo_y1JbGtA/featured" },
    { img: img4, link: "https://www.linkedin.com/company/classplus/" },
    { img: img5, link: "https://api.whatsapp.com/send?phone=918588855952&text=Hi%20Classplus,%20I%20would%20like%20to%20know%20more%20about%20your%20Complete%20Coaching%20Solution" },
    { img: img6, link: "https://mobile.twitter.com/classplusapps?lang=en" },
  ];
  return (
    <div className="Footer">
      <div className="Footer__Body">
        <div className="Footer__Body--Col1">
          <img className="Footer__Body--Col1__Img" src={logo} alt="" />
        </div>
        <div className="Footer__Body--Col2">
          {/* <div className="Footer__Body--Col2__Head">CLASSPLUS</div> */}
          {classplusData.map((data, index) => {
            return (
              <div className="Footer__Body--Col2__Para" key={index} onClick={()=>{window.open(data.link, "_self")}}>
                {data.label}
              </div>
            );
          })}
        </div>
        <div className="Footer__Body--Col3">
          <div className="Footer__Body--Col3__Head">CONTACT INFO</div>
          {contactData.map((data, index) => {
            return (
              <div className="Footer__Body--Col3__Para" key={index}>
                {data}
              </div>
            );
          })}
        </div>
        <div className="Footer__Body--Col4">
          <div className="Footer__Body--Col4__Head">CONNECT WITH US</div>
          <div className="Footer__Body--Col4__Body">
            {connectData.map((data, index) => {
              return (
                <img
                  onClick={()=>{window.open(data.link, '_blank')}}
                  className="Footer__Body--Col4__Body--Img"
                  key={index}
                  src={data.img}
                  alt=""
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="Footer__Foot">
        © 2021 Bunch Microtechnologies Pvt Ltd. All Rights Reserved
      </div>
    </div>
  );
}
